import React from "react";
import { Helmet } from "react-helmet";
import "./DirectoryBreadcrumb.scss";
import AppLink from "@/components/AppLink";
import { BASE_PATH, withBase } from "@/helpers/basePath";

export const DIRECTORY_PATH = "/agents";

export const slugify = (name) =>
  String(name || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/['’.]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const statePath = (stateSlug) => `${DIRECTORY_PATH}/${String(stateSlug || "").toLowerCase()}`;

export const townPath = (stateSlug, townSlug) => `${statePath(stateSlug)}/${townSlug}`;

export const marketPath = (market) => townPath(market.state, slugify(market.city));

export const brokeragePath = (name, place) => {
  const params = new URLSearchParams({ b: name });
  if (place?.lat && place?.long) {
    params.set("city", place.name);
    params.set("state", place.state);
    params.set("lat", String(place.lat));
    params.set("lng", String(place.long));
  }
  return `${DIRECTORY_PATH}?${params.toString()}`;
};

export const glue = (text) => {
  const value = String(text || "");
  const at = value.lastIndexOf(" ");
  return at > 0 ? `${value.slice(0, at)}\u00a0${value.slice(at + 1)}` : value;
};

export const titleFromSlug = (slug) =>
  String(slug || "")
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const milesLabel = (miles) => `${Math.max(1, Math.round(Number(miles) || 0))} mi`;

export const breadcrumbJsonLd = (trail, origin, base = BASE_PATH) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: trail.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.label,
    item: `${origin}${withBase(crumb.href, base)}`,
  })),
});

const origin = () => (typeof window !== "undefined" ? window.location.origin : "");

const DirectoryBreadcrumb = ({ trail }) => (
  <>
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd(trail, origin()))}</script>
    </Helmet>
    <nav className="directory-breadcrumb" aria-label="Breadcrumb">
      <ol>
        {trail.map((crumb, index) => {
          const last = index === trail.length - 1;
          return (
            <li key={crumb.href}>
              {last ? (
                <AppLink href={crumb.href} aria-current="page">
                  {crumb.label}
                </AppLink>
              ) : (
                <>
                  <AppLink href={crumb.href}>{crumb.label}</AppLink>
                  <span className="directory-breadcrumb__sep" aria-hidden="true">
                    /
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  </>
);

export default DirectoryBreadcrumb;
